import React from "react";
import { CalendarCheck } from "lucide-react";
import { withCalendlyTracking, setBookingContext } from "../lib/attribution";

// Standard "Book Your Free Consultation" CTA used everywhere that links to the
// call calendar. Opens the Calendly scheduler in an on-site popup overlay
// (widget.js is loaded in index.html). Falls back to the plain href/link if the
// Calendly script is ever unavailable. Two-line: bold headline + reassurance.
// `context` ({ name, email, result_id, ... }) is remembered so the booking
// completion can be attributed to this visitor.
export const BookingButton = ({
  href,
  target,
  rel,
  onClick,
  context,
  label = "Book Your Free Consultation",
  subline = "30 minutes with Sandra. No obligation. Leave with answers.",
  testid = "booking-cta",
  className = "",
  compact = false,
}) => {
  const trackedHref = withCalendlyTracking(href);

  const handleClick = (e) => {
    if (onClick) onClick(e);
    setBookingContext({ ...(context || {}), location: testid });
    if (typeof window !== "undefined" && window.Calendly) {
      e.preventDefault();
      window.Calendly.initPopupWidget({ url: withCalendlyTracking(href) });
    }
    // else: let the anchor's href open Calendly as a graceful fallback
  };

  return (
    <a
      href={trackedHref}
      target={target}
      rel={rel}
      onClick={handleClick}
      data-testid={testid}
      className={`inline-flex flex-col items-center justify-center text-center rounded-2xl bg-primary text-primary-foreground hover:brightness-110 active:scale-[0.98] transition focus-ring shadow-[0_12px_40px_-8px_rgba(212,175,55,0.6)] cursor-pointer ${
        compact ? "px-5 py-2" : "px-8 py-3.5"
      } ${className}`}
    >
      <span
        className={`flex items-center gap-2 font-black uppercase tracking-wide leading-tight ${
          compact ? "text-[13px]" : "text-sm md:text-base"
        }`}
      >
        <CalendarCheck size={compact ? 15 : 18} />
        {label}
      </span>
      {subline && (
        <span
          className={`mt-0.5 font-medium leading-snug text-primary-foreground/75 ${
            compact ? "text-[10px]" : "text-[11px] md:text-xs"
          }`}
        >
          {subline}
        </span>
      )}
    </a>
  );
};
